import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=23efd5d5&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=23efd5d5&scoped=true&lang=css&"
import style1 from "./Login.vue?vue&type=style&index=1&id=23efd5d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efd5d5",
  null
  
)

export default component.exports
import {QBanner} from 'quasar'
component.options.components = Object.assign({QBanner}, component.options.components || {})
